<div *ngFor="let biomarker of data.requiredBiomarkers">
    <gen-textual-content
            [item]="biomarker"
            [fieldConfig]="geneInfoConf"
    >
    </gen-textual-content>
    <gen-textual-content *ngIf="biomarkersArePartiallyMatched() && biomarkerIsMatched(biomarker)"
                         [item]="matchedItem"
                         [fieldConfig]="conf"
                         [ngClass]="'Marginbox__r-medium tokenLabelGreen'"
    >
    </gen-textual-content>
    <gen-textual-content *ngIf="biomarkersArePartiallyMatched() && !biomarkerIsMatched(biomarker)"
                         [item]="notReportedItem"
                         [fieldConfig]="conf"
                         [ngClass]="'tokenLabelRed'"
    >
    </gen-textual-content>
</div>
